import apiEndpoints from "@/services/apiEndpoints";
import {dateWithWeekDay} from "@/filters";
import sweetAlert from "@/mixins/sweetAlert";
import tableSearch from "@/mixins/tableSearch";
import pagination from "@/mixins/pagination";

export default {
  mixins: [ sweetAlert, tableSearch, pagination ],
  data() {
    return {
      inquiries: [],
      isLoading: false,
      filters: {
        discharger_name_abbreviated: this.$route.query.discharger_name_abbreviated || "",
        discharger_site_name_abbreviated: this.$route.query.discharger_site_name_abbreviated || "",
        zz_inquiry_type_id: this.$route.query.zz_inquiry_type_id || "",
        zz_inquiry_status_id: this.$route.query.zz_inquiry_status_id || "",
        start_datetime: this.$route.query.start_datetime || "",
        end_datetime: this.$route.query.end_datetime || "",
        column: this.$route.query.column || "submit_at",
        dir: this.$route.query.dir || "DESC",
        page: Number(this.$route.query.page) || 1,
      },
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      const sendApi = await this.$http.get(apiEndpoints.search_inquiries, this.filters);
      const {status, data} = sendApi;

      if (status && data.result) {
        const result = data.result;

        const inquiries = this.$_.isEmpty(result.data) ? [] : result.data;
        this.inquiries = this.transferData(inquiries);
        const meta = this.$_.isEmpty(result.meta) ? [] : result.meta;
        this.setMeta(meta);
      } else {
        this.errorToast(data.message, false, 5000, "top-end");
        this.inquiries = [];
      }
      this.isLoading = false;
    },
    transferData(data) {
      return data.map(item => {
        const formattedCreatedDate = dateWithWeekDay(item.created_at, 'YYYY/MM/DD');
        const formattedSubmitAtDate = item.latest_submit_at ? dateWithWeekDay(item.latest_submit_at, 'YYYY/MM/DD') : "";

        return {...item, created_at: formattedCreatedDate, submit_at: formattedSubmitAtDate};
      });
    },
    async onSearch() {
      this.resetToFirstPage();
      this.updateUrlFilters();
    },
    onClearFilters() {
      this.resetFilters();
      this.resetToFirstPage();
      this.updateUrlFilters();
    },
    resetFilters() {
      for (const key in this.filters) {
        this.filters[key] = ""
      }
      this.filters.column = "submit_at";
      this.filters.dir = "DESC";
    },
    openinQuiryDetailModal(inquiry) {
      this.$refs.inquiryDetail.openModal(inquiry);
    },
    onAnswered(isAnswered) {
      if (isAnswered) {
        this.updateUrlFilters();
      }
    }
  },
  computed: {
    inquiryTypes() {
      return this.$store.getters['options/options_tables'].zz_inquiry_types ?? [];
    },
  },
  watch: {
    'filters.zz_inquiry_status_id': {
      handler: function (newVal) {
        this.filters.zz_inquiry_status_id = (newVal === false) ? '' : this.filters.zz_inquiry_status_id;
      },
      immediate: true,
    },
    "filters.page": {
      immediate: false,
      handler(newVal, oldVal) {
        this.updateFiltersWithoutSearch();
        this.updateUrlFilters();
      }
    },
  }
}